import React, { useContext } from 'react';
import { useTheme } from 'ThemeContext';
import { Spacer, Title, Wrapper } from './WidgetTitle.style';
import { AppSettingsContext } from 'AppSettingsContext';

function WidgetTitle({
  title = '',
  titleColor = undefined,
  titleBackground = undefined
}) {
  const [appSettings] = useContext(AppSettingsContext);
  const theme = useTheme();
  return (
    <Wrapper>
      {title ? (
        <Title
          theme={theme.widgetTitle.title}
          titleColor={titleColor}
          titleBackground={titleBackground}
        >
          {title}
        </Title>
      ) : (
        ''
      )}
      {theme.widgetTitle.spacer.isSpacer ? (
        <Spacer theme={theme.widgetTitle.spacer} />
      ) : (
        ''
      )}
    </Wrapper>
  );
}

export default WidgetTitle;
